export const PAYPAL_SCREEN_KEYS = {
  ERROR_TEXT_1: {
    key: 'MDP_MetodosDePago_ModalError_Parrafo_Texto1_paypalgate',
  },
  ERROR_TEXT_2: {
    key: 'MDP_MetodosDePago_ModalError_Parrafo_Texto2_paypalgate',
  },
  ERROR_TEXT_3: {
    key: 'MDP_MetodosDePago_ModalError_Parrafo_Texto3_paypalgate',
  },
};

export const PAYPAL_ACCOUNTS_ACTIONS_KEYS = {
  ADD_ACCOUNT_BUTTON: {
    key: 'mdp_metodosdepago_editarmdppaypal_boton_texto_agregarcuentapaypal',
    length: 22,
  },
};

// Sufijadas por gateway ('paypalgate') vía translationMapper.
export const PAYPAL_ACCOUNTS_GRID_SCREEN_KEYS = {
  SUCCESS_TEXT_1: { key: 'MDP_MetodosDePago_ModalVerificacion_Parrafo_Texto1' },
  SUCCESS_TEXT_2: { key: 'MDP_MetodosDePago_ModalVerificacion_Parrafo_Texto2' },
};

export const PAYPAL_LINK_ACCOUNT_SCREEN_KEYS = {
  TEXT_1: {
    key: 'mdp_metodosdepago_agregarmdppaypal_parrafo_texto1',
    length: 26,
  },
  TEXT_2: {
    key: 'mdp_metodosdepago_agregarmdppaypal_parrafo_texto2',
    length: 6,
  },
  TEXT_5: {
    key: 'mdp_metodosdepago_agregarmdppaypal_parrafo_texto5',
    length: 35,
  },
  TEXT_3: {
    key: 'mdp_metodosdepago_agregarmdppaypal_parrafo_texto3',
    length: 35,
  },
  TEXT_4: {
    key: 'mdp_metodosdepago_agregarmdppaypal_parrafo_texto4',
    length: 35,
  },
};

export const PAYPAL_ACCOUNT_DETAIL_SCREEN_KEYS = {
  UNLINK_TITLE: {
    key: 'mdp_metodosdepago_modaldesvincularpaypal_titulo_texto',
    length: 74,
  },
  UNLINK_DESCRIPTION: {
    key: 'mdp_metodosdepago_modaldesvincularpaypal_parrafo_texto',
    length: 82,
  },
  UNLINK_CONFIRM_BTN: {
    key: 'mdp_boton_texto_desvincular',
    length: 22,
  },
  SUSCRIPTIONS_TITLE: {
    key: 'mdp_metodosdepago_modaleliminarsuscripcionespaypal_titulo_texto',
    length: 74,
  },
  SUSCRIPTIONS_DESCRIPTION: {
    key: 'mdp_metodosdepago_modaleliminarsuscripcionespaypal_parrafo_texto',
    length: 84,
  },
  SUSCRIPTIONS_CONFIRM_BTN: {
    key: 'mdp_boton_texto_irasuscripciones',
    length: 22,
  },
  SUSCRIPTIONS_CANCEL_BTN: {
    key: 'mdp_boton_texto_cerrar',
    length: 22,
  },
  INTERMITTENCE_ERROR: {
    key: 'MDP_MetodosDePago_ModalError_Parrafo_Texto_IntermitenciaSistema',
  },
};
